module.exports = __webpack_public_path__ + "media/fonts/dinot/dinotmedium-e0754bd67f67a5323eef642b60d9dfdb.woff2";